import { useAccountContext } from 'application/providers/AccountProvider';

import { Country } from 'domain/api/graphql/generated';

interface UseModalContentViewModel {
  companyCountry: Country;
}

const useModalContentViewModel = (): UseModalContentViewModel => {
  const { currentCompany } = useAccountContext();

  return {
    companyCountry: currentCompany?.country || Country.Ru,
  };
};

export default useModalContentViewModel;
